import { POIINFOEXPAND } from "../../actions/portal/";

export default function(state = false, action) {
  switch (action.type) {
    case POIINFOEXPAND:
      return action.payload;
    default:
  }

  return state;
}
